import { render, staticRenderFns } from "./PromotionDialog.vue?vue&type=template&id=e98b8a12&"
import script from "./PromotionDialog.vue?vue&type=script&lang=ts&"
export * from "./PromotionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports